module.exports = __webpack_public_path__ + "static/media/LogoWhite.3b448931.svg";